<div fxLayout fxLayoutGap="16px">
    <dsh-action-item iconName="person" [dshDropdownTriggerFor]="userDropdown"></dsh-action-item>
</div>

<dsh-dropdown width="302px" #userDropdown="dshDropdown">
    <ng-template><dsh-user (selected)="closeDropdown()"></dsh-user></ng-template>
</dsh-dropdown>
